import { mapActions } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  props: {
    step: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    params() {
      let params = {};
      if (!isEmpty(this.step)) {
        params = {
          bgnYmdhms: this.step.bgnYmdhms,
          sstmId: this.step.sstmId,
          instId: this.step.instId,
          seq: this.step.seq,
        };
      }
      return params;
    },
  },
  watch: {
    params(value) {
      if (this.fetch !== undefined) {
        this.fetch(value);
      }
    },
  },
  created() {
    // TASK/MEMORY, BYTE는 TIME에서 fetch한 데이터를 store를 통해 사용하기 때문에
    // fetch 함수가 없다. this.fetch가 있는지 여부를 확인이 필요
    if (this.fetch !== undefined) {
      this.fetch(this.params);
    }
  },
  methods: {
    ...mapActions('analysis/ssr', ['increaseLoadingCount']),
  },
};
